exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stars-input[data-v-df8b031c] {\np {\n    margin-bottom: 12px;\n    color: #2F4286;\n}\n.stars {\n    display: flex;\n    gap: 10px;\n@media screen and (max-width: 600px) {\n      gap: 6px;\n}\n}\n.star {\n    width: 28px;\n    min-width: 28px;\n    color: #2F42861A;\n@media screen and (max-width: 600px) {\n      width: 20px;\n      min-width: 20px;\n}\n}\n.star.filled svg path {\n    fill: #2f4286;\n}\n.input-hidden {\n    display: none;\n}\n}\n", ""]);

// exports
